import { RiCamera3Line } from "@itandi/itandi-bb-ui";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { ScheduleInputModal } from "~/components/common/vendors/visit_schedule/ScheduleInputModal";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import { useDeals } from "~/hooks/vendors/useDeals";
import { formatDate } from "~/utils/DateUtil";
import Styles from "../DealCard.module.scss";

export function DealVisitDateVendorCard() {
	const id = useIdQueryHandler();
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const show = useDeals().show(id);

	const deal = show.data!;
	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>
				<RiCamera3Line className={Styles.TitleIcon} />
				<span>
					{deal.inspectionBy !== "none" ? "立会日程・" : ""}現地調査日程
				</span>
				<div className={Styles.EditButtonWrapper}>
					<EditMenuButton onClick={handleOpen}>変更</EditMenuButton>
					<ScheduleInputModal
						deal={deal}
						handleClose={handleClose}
						handleMutate={async (): Promise<void> => {
							await show.mutate();
						}}
						isOpen={isOpen}
					/>
				</div>
			</h3>
			<div className={Styles.Content}>
				{deal.inspectionBy !== "none" && (
					<dl className={Styles.ListContent}>
						<dt className={Styles.ListContentCaption}>立会日程</dt>
						<dd className={Styles.ListContentValue}>
							{deal.inspectionDate === null ? (
								<span className={Styles.NotYet}>未定</span>
							) : (
								<span>{formatDate(deal.inspectionDate, true)}</span>
							)}
						</dd>
					</dl>
				)}
				<dl className={Styles.ListContent}>
					<dt className={Styles.ListContentCaption}>現地調査日程</dt>
					<dd className={Styles.ListContentValue}>
						{deal.surveyDate === null ? (
							<span className={Styles.NotYet}>未定</span>
						) : (
							<span>{formatDate(deal.surveyDate, true)}</span>
						)}
					</dd>
				</dl>
			</div>
		</div>
	);
}
